import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { MenuItem, TextField, Grid, Button } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import { notify } from '../../services/notify.js';
import { useAuth } from '../../services/AuthContext.js';
import {
  Card,
  CardContent,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  InputAdornment
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { constants } from 'buffer';
import { getCycleLabel } from '../../config/subscription.js';
import "./checkout.css";

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}

const StartFormEdit = ({
  name,
  email,
  phone,
  cpf,
  setName,
  setEmail,
  setPhone,
  setCpf,
  errors,
  handleSubmit,
  inside,
  setStep,
}) => {
  return (
    <div className="auth-container">
      <div className="contact_form startform-container">
        <h2 className="startform-title">Alteração do cartão de crédito usado na assinatura</h2>
        <h3 className="startform-title">1. Dados pessoais</h3>

        <p className="startform-subtitle">
          Preencha os dados abaixo para alterar o cartão de crédito usado na sua assinatura.
        </p>

        <div className="formfield">
          <TextField
            label="Nome completo"
            variant="outlined"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="formfield">
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="formfield">
          <TextField
            label="Celular com DDD"
            variant="outlined"
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>

        <div className="formfield">
          <TextField
            label="CPF (apenas números)"
            variant="outlined"
            fullWidth
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
            required
          />
        </div>

        {errors && <p className="errormsg">{errors}</p>}

        <div className="startform-footer">
          <Button
            onClick={handleSubmit}
            className="btn-continue"
            variant="contained"
            color="success"
          >
            Continuar
          </Button>
        </div>

        <p className="trust-text">🔒 Dados seguros e protegidos. Para maior segurança, não armazenamos dados de cartão de crédito nas bases de dados do Domínio Elétrico. Deixamos para o nosso processador de pagamentos, o Asaas, gerenciar isso.</p>
      </div>
    </div>
  );
};

/* 
res = {
            "description": data["description"],
            "cycle": data["cycle"],
            "value": data["value"],
            "dateCreated": data["dateCreated"],
            "nextDueDate": data["nextDueDate"],
            "billingType": data["billingType"],
            "creditCardNumber": data["creditCard"]["creditCardNumber"],
            "creditCardBrand": data["creditCard"]["creditCardBrand"]
        }
*/

const ConfirmSubscriptionInfo = ({
  description,
  cycle,
  value,
  dateCreated,
  nextDueDate,
  creditCardNumber,
  creditCardBrand,
  handleSubmit,
  setStep
}) => {
  return (
    <div className="auth-container">
      <div className="contact_form startform-container">
        <h2 className="startform-title">Alteração do cartão de crédito usado na assinatura</h2>
        <h3 className="startform-title">2. Confirmação da assinatura</h3>

        <p className="startform-subtitle">
          Verifique os dados atuais da sua assinatura e do cartão usado antes de continuar.
        </p>

        <p className="startform-text">
          <b>Descrição:</b> {description}
        </p>

        <p className="startform-text">
          <b>Plano:</b> {getCycleLabel(cycle).toLowerCase()}
        </p>

        <p className="startform-text">
          <b>Valor:</b> R$ {value}
        </p>

        <p className="startform-text">
          <b>Data de início:</b> {dateCreated}
        </p>

        <p className="startform-text">
          <b>Próximo vencimento:</b> {nextDueDate}
        </p>

        <p className="startform-text">
          <b>Cartão de crédito atual:</b> **** **** **** {creditCardNumber}
        </p>

        <p className="startform-text">
          <b>Bandeira:</b> {creditCardBrand}
        </p>

        <div className="startform-footer">
          <button className="cardinfo-back" onClick={() => setStep('start')}>
            {'<< Voltar'}
          </button>
          <Button
            onClick={handleSubmit}
            className="btn-continue"
            variant="contained"
            color="success"
          >
            Continuar
          </Button>
        </div>
      </div>
    </div>
  );
};

const CepField = ({ cep, setCep, endereco, setEndereco }) => {
  const handleCepChange = (e) => {
    const value = e.target.value;
    setCep(value);

    if (value.length === 9 && value.includes('-')) {
      buscarEndereco(value);
    } else if (value.length === 8 && !value.includes('-')) {
      const formattedCep = `${value.slice(0, 5)}-${value.slice(5)}`;
      setCep(formattedCep);
      buscarEndereco(formattedCep);
    }
  };

  const buscarEndereco = async (cep) => {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();

    if (!data.erro) {
      setEndereco({
        rua: data.logradouro || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        estado: data.uf || '',
        numero: '',
      });
    }
  };

  return (
    <div className="cep-container">
      <InputLabel className="cep-label">CEP e endereço</InputLabel>

      <div className="cep-field">
        <TextField
          label="CEP"
          variant="outlined"
          value={cep}
          onChange={handleCepChange}
          fullWidth
          required
          inputProps={{ maxLength: 9 }}
        />
      </div>

      {cep.length === 9 && (
        <div className="cep-fields-expanded">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                label="Rua"
                value={endereco.rua}
                onChange={(e) =>
                  setEndereco((prev) => ({ ...prev, rua: e.target.value }))
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Número"
                value={endereco.numero}
                onChange={(e) =>
                  setEndereco((prev) => ({ ...prev, numero: e.target.value }))
                }
                fullWidth
              />
            </Grid>
          </Grid>

          <div className="cep-field">
            <TextField
              label="Complemento"
              value={endereco.complemento}
              onChange={(e) =>
                setEndereco((prev) => ({ ...prev, complemento: e.target.value }))
              }
              fullWidth
            />
          </div>

          <div className="cep-field">
            <TextField
              label="Bairro"
              value={endereco.bairro}
              onChange={(e) =>
                setEndereco((prev) => ({ ...prev, bairro: e.target.value }))
              }
              fullWidth
            />
          </div>

          <div className="cep-field">
            <TextField
              label="Cidade"
              value={endereco.cidade}
              onChange={(e) =>
                setEndereco((prev) => ({ ...prev, cidade: e.target.value }))
              }
              fullWidth
            />
          </div>

          <div className="cep-field">
            <TextField
              label="Estado"
              value={endereco.estado}
              onChange={(e) =>
                setEndereco((prev) => ({ ...prev, estado: e.target.value }))
              }
              fullWidth
            />
          </div>
        </div>
      )}
    </div>
  );
};

const AddressInfoEdit = ({ errors, cep, setCep, endereco, setEndereco, setStep, handleSubmit }) => {
  return (
    <div className="address-container">
      <h2 className="address-title">Alteração do cartão de crédito usado na assinatura</h2>
      <h3 className="address-title">3. Endereço</h3>
      <p className="address-description">
        Para que o seu cartão de crédito seja validado, informe o mesmo endereço
        cadastrado no banco emissor do seu cartão.
      </p>

      <div className="address-fields">
        <CepField 
          cep={cep}
          setCep={setCep}
          endereco={endereco}
          setEndereco={setEndereco}
        />
      </div>

      <p className="address-error">{errors}</p>

      <div className="address-buttons">
        <button className="cardinfo-back" onClick={() => setStep('confirmation')}>
          {'<< Voltar'}
        </button>
        <Button
          onClick={handleSubmit}
          className="address-submit"
          variant="contained"
          color="primary"
        >
          Prosseguir para os dados do cartão
        </Button>
      </div>
    </div>
  );
};

const EndFormEdit = ({ payStatus }) => {

  return (
    <div className="end-container">
      <div className="end-content">
        <h2 className="end-title">Alteração do cartão de crédito usado na assinatura</h2>
        <h3 className="end-title">🎉 Os dados do cartão de crédito usado na sua assinatura foram atualizados com sucesso.</h3>

        <p className={`end-status ${payStatus === 'CONFIRMED' ? 'confirmed' : 'pending'}`}>
        </p>

        <div className="end-info">
          <p>As próximas cobranças serão feitas no novo cartão de crédito.</p>
        </div>
      </div>
    </div>
  );
};

const CardInfoEdit = ({
  month,
  year,
  setMonth,
  setYear,
  card_cvv,
  setCard_CVV,
  card_name,
  setCard_name,
  card_number,
  setCard_number,
  errors,
  setStep,
  handleSubmit,
  isSubmitting,
}) => {
  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i);

  return (
    <div className="cardinfo-container">
      <h2 className="address-title">Alteração do cartão de crédito usado na assinatura</h2>
      <h3 className="cardinfo-title">4. Dados do cartão de crédito</h3>
      <p className="cardinfo-description">
        Digite os dados exatamente como aparecem no cartão. Erros de digitação podem impedir a aprovação.
      </p>

      <div className="cardinfo-field">
        <InputLabel className="cardinfo-label">Nome impresso no cartão</InputLabel>
        <TextField
          label="Nome impresso no cartão"
          variant="outlined"
          value={card_name}
          onChange={(e) => setCard_name(e.target.value)}
          fullWidth
          required
        />
      </div>

      <div className="cardinfo-field">
        <InputLabel className="cardinfo-label">Número do cartão (16 dígitos)</InputLabel>
        <TextField
          label="Número do cartão"
          variant="outlined"
          value={card_number}
          onChange={(e) => setCard_number(e.target.value)}
          fullWidth
          required
        />
      </div>

      <div className="cardinfo-field">
        <InputLabel className="cardinfo-label">Vencimento (Mês/Ano) e código CVV</InputLabel>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              select
              label="Mês"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              fullWidth
              required
            >
              {months.map((m, i) => (
                <MenuItem key={i} value={i + 1}>{m}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={4}>
            <TextField
              select
              label="Ano"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              fullWidth
              required
              SelectProps={{
                MenuProps: { PaperProps: { style: { maxHeight: 200 } } }
              }}
            >
              {years.map((a) => (
                <MenuItem key={a} value={a}>{a}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="CVV"
              variant="outlined"
              value={card_cvv}
              onChange={(e) => setCard_CVV(e.target.value)}
              fullWidth
              required
            />
          </Grid>
        </Grid>
      </div>

      <div className="cardinfo-summary">
        <p className="cardinfo-summary-title">Observação</p>
        <p>As próximas cobranças serão feitas neste novo cartão, nas mesmas datas.</p>
      </div>

      <p className="cardinfo-error">{errors}</p>

      <div className="cardinfo-actions">
        <button className="cardinfo-back" onClick={() => setStep('addressinfo')}>
          {'<< Voltar'}
        </button>

        <Button
          disabled={isSubmitting}
          onClick={handleSubmit}
          className="cardinfo-submit"
          variant="contained"
          color="primary"
        >
          {isSubmitting ? "Processando..." : "Atualizar cartão de crédito"}
        </Button>
      </div>
    </div>
  );
};

const EditCreditCard = ({ isMobile, inside }) => {
  const query = useQuery();
  const userIdFromQuery = query.get("u");
  const [step, setStep] = useState('start'); 
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [cep, setCep] = useState('');
  const [endereco, setEndereco] = useState({
    rua: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
  });
  const [cpf, setCpf] = useState('');
  const [card_name, setCard_name] = useState('');
  const [card_number, setCard_number] = useState('');
  const [card_month, setCard_month] = useState(1);
  const [card_year, setCard_year] = useState(2025);
  const [card_cvv, setCard_CVV] = useState(2025);
  const [errors, setErrors] = useState();
  const [payStatus, setPayStatus] = useState('PENDING');
  const [customer_id, setCustomerId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user, loading, getIdToken } = useAuth(); 
  const [userId, setUserId] = useState(userIdFromQuery);
  const alreadyNotified = useRef(false);

  const [currentDescription, setCurrentDescription] = useState('');
  const [currentCycle, setCurrentCycle] = useState('');
  const [currentValue, setCurrentValue] = useState('');
  const [currentDateCreated, setCurrentDateCreated] = useState('');
  const [currentNextDueDate, setCurrentNextDueDate] = useState('');
  const [currentCreditCardNumber, setCurrentCreditCardNumber] = useState('');
  const [currentCardBrand, setCurrentCardBrand] = useState('');

  useEffect(() => {
    if (loading) return; // Aguarda o carregamento do usuário
    setEmail(user.attributes.email);
    setName(user.attributes.name);
    setUserId(user.attributes.sub);
    if (!alreadyNotified.current) {
      alreadyNotified.current = true;
      notify("EDIT CARD PAGEVIEW", `O usuário ${user.attributes.email} acessou a página de alterar cartão de crédito do site!`);
    }
    return () => {};
  }, [user]);

  const validateStart = () => {
    let rvalue = true;
    let error_message = "Erros: ";
    setErrors('');
    if (!name.trim()) {
      error_message += "Nome é obrigatório; ";
      rvalue = false;
    }
    if (!email.includes('@')) {
      error_message += "e-mail inválido; ";
      rvalue = false;
    }
    if (!validPhone(phone)) {
      error_message += "celular inválido; ";
      rvalue = false;
    }
    if (!validCPF(cpf)) {
      error_message += "CPF inválido; ";
      rvalue = false;
    }
    if (rvalue) error_message = "";
    setErrors(error_message);
    return rvalue;
  };

  const validPhone = (phone) => {
    const regex = /^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/;
    return regex.test(phone);
  };

  const validCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, ''); // Remove pontos e hífens
  
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;
  
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;
  
    return true;
  };

  const validateAddressinfo = () => {
    let rvalue = true;
    let error_message = "Erros: ";
    setErrors('');
    // Birthday is not needed
    /* if (day === 31 && month === 2) {
      error_message += "Data de nascimento inválida; ";
      rvalue = false;
    } */
    if (!cep.match(/^\d{5}-?\d{3}$/)) {
      error_message += "CEP inválido; ";
      rvalue = false;      
    }
    if (!endereco.rua.trim()) {
      error_message += "Rua inválida; ";
      rvalue = false; 
    }
    if (!endereco.numero.match(/^\d+$/)) {
      error_message += "Número inválido; ";
      rvalue = false; 
    }
    if (!endereco.bairro.trim()) {
      error_message += "Bairro inválido; ";
      rvalue = false; 
    }
    if (!endereco.cidade.trim()) {
      error_message += "Cidade inválida; ";
      rvalue = false; 
    }
    if (!endereco.estado.trim()) {
      error_message += "Estado inválido; ";
      rvalue = false; 
    }
    if (rvalue) error_message = "";
    setErrors(error_message);
    return rvalue;
  };

  const validateCard = () => {
    let rvalue = true;
    let error_message = "Erros: ";
    setErrors('');
    if (!card_name.trim()) {
      error_message += "Nome do cartão inválido; ";
      rvalue = false;
    }
    if (!card_number.replace(/\s+/g, '').match(/^\d{16}$/)) {
      error_message += "Número de cartão inválido; ";
      rvalue = false;      
    }
    if (card_cvv.length !== 3) {
      error_message += "CVV inválido; ";
      rvalue = false; 
    }
    if (rvalue) error_message = "";
    setErrors(error_message);
    return rvalue;
  };

  async function updateCardInfo() {
    const payload = {
      name: name,
      cpfCnpj: cpf,
      email: email,
      phone: phone,
  
      cep: cep,
      address: endereco.rua,
      province: endereco.bairro,
      addressNumber: endereco.numero,
      addressComplement: endereco.complemento,
  
      holderName: card_name,
      cardNumber: card_number,
      expiryMonth: card_month,
      expiryYear: card_year,
      cvv: card_cvv 
    };

    try {
      const token = await getIdToken();     
      const response = await fetch(`${baseAPI_URL}/subscriptions/update-card-info`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
  
      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error updating card info:", error);
    }
  }

  async function getCurrentSubscriptionInfo(cpfCnpj) {
    try {
      const token = await getIdToken();
      const response = await fetch(`${baseAPI_URL}/subscriptions/get-subscription-info/${cpfCnpj}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
      });
  
      const result = await response.json();
      setCurrentDescription(result.description);
      setCurrentCycle(result.cycle);
      setCurrentValue(result.value);
      setCurrentDateCreated(result.dateCreated);
      setCurrentNextDueDate(result.nextDueDate);
      setCurrentCreditCardNumber(result.creditCardNumber);
      setCurrentCardBrand(result.creditCardBrand);
      return result;
    } catch (error) {
      console.error("Error in getCurrentSubscriptionInfo:", error);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step === 'start') {
      if (validateStart()) {
        try {
          const result = await getCurrentSubscriptionInfo(cpf);
        } catch (error) {
          console.error("Error:", error);
        }
        setStep('confirmation');
      }
    }
    else if (step == "confirmation") {
      setStep('addressinfo');
    }
    else if (step === 'addressinfo') {
      if (validateAddressinfo()) {
        notify("EDIT CARD: addressinfo > card", "Alguém entrou no edit card e foi do addressinfo para card.");
        setStep('card');
      }
    } 
    else if (step === 'card') {
      if (validateCard() && !isSubmitting) {
        setIsSubmitting(true);
        try {
          const result = await updateCardInfo();
          if (result.status === "ok") {
            setPayStatus("CONFIRMED");
            notify("EDIT CARD: card", "Alguém conseguiu alterar os dados do cartão de crédito.");
            setStep('end');
          } else {
            setErrors(result.message);
            notify("EDIT CARD: card", "Alguém chegou à parte final do edit card, mas deu problema.");
          }
        } catch (error) {
          console.error("Error in updateCardInfo:", error);
        } finally {
          setIsSubmitting(false); // unlock submission
        }
      } 
    }
  };

  return (
    <section id="form" className="edit-credit-card">
      <div className="checkout-content">
        {step === 'start' && (
        <StartFormEdit
        name={name}
        email={email}
        phone={phone}
        cpf={cpf}
        setName={setName}
        setEmail={setEmail}
        setPhone={setPhone}
        setCpf={setCpf}
        errors={errors}
        handleSubmit={handleSubmit}
        inside={inside}
        setStep={setStep}
        />
      )}

      {step === 'confirmation' && (
        <ConfirmSubscriptionInfo
        description={currentDescription}
        cycle={currentCycle}
        value={currentValue}
        dateCreated={currentDateCreated}
        nextDueDate={currentNextDueDate}
        creditCardNumber={currentCreditCardNumber}
        creditCardBrand={currentCardBrand}
        handleSubmit={handleSubmit}
        setStep={setStep}
        />
      )}

      {step === 'addressinfo' && (
        <AddressInfoEdit
        errors={errors}
        cep={cep}
        setCep={setCep}
        endereco={endereco}
        setEndereco={setEndereco}
        setStep={setStep}
        handleSubmit={handleSubmit}
        />
      )}

      {step === 'card' && (
        <CardInfoEdit
        month={card_month}
        year={card_year}
        card_cvv={card_cvv}
        setMonth={setCard_month}
        setYear={setCard_year}
        setCard_CVV={setCard_CVV}
        card_name={card_name}
        setCard_name={setCard_name}
        card_number={card_number}
        setCard_number={setCard_number}
        errors={errors}
        setStep={setStep}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        />
      )}

      {step === 'end' && (
        <EndFormEdit 
        payStatus={payStatus}
        />
        )}
      </div>
    </section>
  );
};

export default EditCreditCard;